<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [title]="'Pro Search Agent'"
      [class]="extraClass"
      [canGoBack]="true"
      [customBack]="backPage" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true">

    @if (windowService?.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-image
            style="z-index: 1000"
            [src]="'assets/svg/arrow-back-black.svg'"
            (action)="goBack()"
            class="desktop-back-icon" />
          <tidy-text
            [title]="'Pro Search Agent'" />
          <tidy-header-select
            [items]="propertyFiltersList"
            [form]="form.get('propertyFilter')"
            (optionChange)="changePropertyFilter($event)"
            [icon]="'assets/svg/home.svg'" />
        </div>
      </tidy-desktop-header>
    }

    <!-- Skeleton table while loading — rows float in with the entrance cascade;
         the real table below then replaces it in place, instantly (skipEntrance). -->
    @if (windowService?.isDesktopRes && !loaded) {
      <tidy-table
        [skeletonLoading]="true"
        [columnslabels]="headers" />
    }

    @if (loaded) {
      @if (currentRows.length === 0) {
        <tidy-card>
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'No pro search agent workflows found. Add a pro to a property to create a workflow.'" />
          </tidy-row>
        </tidy-card>
      } @else {
        @if (windowService.isDesktopRes) {
          <tidy-table
            [dataSource]="currentRows"
            [displayedColumns]="headers"
            [columnslabels]="headers"
            [allRowIsClickable]="true"
            [showColumnLines]="false"
            (cellClick)="goToWorkflow($event)"
            [skipEntrance]="true"
            [blockSorting]="true" />
        } @else {
          @for (row of currentRows; track row['Properties'].addressId) {
            <tidy-card>
              <tidy-card-button
                (action)="goToWorkflowFromCard(row)"
                class="arrow-to-top no-padding">
                <tidy-row>
                  <tidy-tag
                    [color]="row['Properties'].color"
                    [addressId]="row['Properties'].addressId" />
                  <tidy-text
                    [header]="row['Properties'].value"
                    [translate]="false" />
                </tidy-row>
                <tidy-row class="extra-top-padding vertical-align-middle">
                  <img
                    [src]="row['Service'].icon"
                    class="service-icon" />
                  <tidy-text
                    [body]="row['Service'].value"
                    [translate]="false" />
                </tidy-row>
                <tidy-row class="vertical-align-middle">
                  <tidy-image
                    [src]="'assets/img/settings-blue.svg'"
                    class="action-icon" />
                  <tidy-text
                    [helper]="row['Actions'].value"
                    [translate]="false" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
        }
      }
    }

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" />
